module.exports = __webpack_public_path__ + "static/media/Practice1.3321971b.bmp";